var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('modify-table',{ref:"orders",on:{"clearDetails":_vm.clearDetails,"showDetails":_vm.showDetails}}),_c('modify-detail',{ref:"details"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }